// Honor / Ethics (CR-4) — a 0–10 reputation rating shown in the Registry.
// Honor rises with self-education, regular play (discipline), and taxing your
// citizens lightly; it falls toward 0 as you tax heavily / neglect the kingdom.
// Reputation-only for now (doesn't gate mechanics yet).
//
//   honor = base
//         + education   (per degree level, capped)
//         + low-tax     (max at 0% tax → 0 at the max rate)
//         + engagement  (consistent play, via the login streak)
//         + feeding      [TODO CR-6: needs a feed-cadence metric]
//   clamped to [min, max]

import { HonorConfig, TaxConfig } from '../config/balance.js'
import { getProfile } from './state.js'
import { getTaxRate } from './seasonManager.js'
import { getStreak } from './accountManager.js'
import { promotedCount } from './citizens.js'

// Σ honor from the player's degrees, capped. Reads the CR-6 shape
// (subject → 'CERT' | 'MASTERS' | 'PHD'); unknown/legacy values count as 0.
function educationHonor(degrees) {
  let sum = 0
  for (const v of Object.values(degrees ?? {})) {
    const lvl = String(v).toUpperCase()
    if (lvl === 'PHD') sum += HonorConfig.perPhd
    else if (lvl === 'MASTERS') sum += HonorConfig.perMasters
    else if (lvl === 'CERT') sum += HonorConfig.perCert
  }
  return Math.min(HonorConfig.educationCap, sum)
}

export function getHonor() {
  const c = HonorConfig
  let h = c.base
  h += educationHonor(getProfile().degrees)
  // Low-tax: full bonus at 0% tax, scaling to 0 at the max rate.
  const taxFrac = TaxConfig.maxRate > 0 ? getTaxRate() / TaxConfig.maxRate : 0
  h += c.lowTaxMax * (1 - Math.min(1, taxFrac))
  // Engagement: consistent play, proxied by the login streak (days).
  const streak = getStreak()?.current ?? 0
  h += c.engagementMax * Math.min(1, streak / c.engagementIdealDays)
  // Civic leadership (CR-8): promoting citizens to trades raises Honor, capped.
  h += Math.min(c.civicMax, promotedCount() * c.perPromotion)
  // The court caught you running off with a host's coffer (game/coopManager.js keeps the count from the server): each time costs Honor, up to a cap.
  h -= Math.min(c.theftMax, (getProfile().coopCaught ?? 0) * c.perTheftCaught)
  // TODO: feeding cadence + starvation/abandonment penalties.
  return Math.max(c.min, Math.min(c.max, h))
}

// Two-decimal string for the Registry (e.g. "8.86").
export function getHonorDisplay() {
  return getHonor().toFixed(2)
}
